import * as _ from 'lodash';
import {
    IAdminData,
    IAnatomyPrefsData,
    ILabData,
    IProfileData,
    ISerologyData,
    IServicesData,
    ISrtrData
} from '@nkr/models/index';
import { IProfileDataValidation } from './profile-data/validation';
import { ISerologyDataValidation } from './serology/validation';
import { IServicesDataValidation } from './services/validation';
import { ISrtrDataValidation } from './srtr/validation';
import { CenterOnOffPilot } from '@nkr/enums/center-on-off-pilot';
import { CenterOrganType, DonorShieldStatus, YesNo } from '@nkr/enums/index';
import { IAdminDataValidation } from './admin/validation';

export const initialAdminData: IAdminData = {
    alias: '',
    betaActivationStatus: CenterOnOffPilot.Off,
    dashDomain: '',
    excludeDataCompliance: YesNo.Unknown,
    userName: '',
    password: '',
    billingModel: '0',
    rmcrFeeMajor: 0,
    rmcrFeeMinor: 0,
    rmcrIsContractFeeWaived: YesNo.No,
    overrideDonorsProtectedKidney: YesNo.No,
    overrideDonorsProtectedLiver: YesNo.No,
    isLiverDonorShieldARCenter: YesNo.No,
    isInactivityFeeWaived: YesNo.No,
    monthlyFee: '',
    monthlyFeeNotes: '',
    dashFee: '',
    dashNotes: '',

    achRoutingNumber: '',
    achAccountNumber: '',

    organPackaging: YesNo.No,
    packagingAchRoutingNumber: '',
    packagingAchAccountNumber: '',
    packagingAchApproved: 0,

    donorShieldFee: '',
    liverDonorShieldFee: '',
    transplantsCompleted: 0,

    invoicePoNumber: '',
    poAmount: '',
    poBalance: '',
    invoicePoStartDate: '',
    invoicePoExpirationDate: '',
    invoiceDaysToRemit: '0',

    nkrLiaisonId: 0,
    executiveSponsorId: 0,
    defaultMicrositeCoachUserId: 0,
    isAcceptingReferrals: YesNo.Unknown,
    nddReferrals: YesNo.Unknown,
    isDeleted: YesNo.Unknown,
    isTestCenter: YesNo.Unknown,
    memberCenterType: null,
    isBillableKidney: YesNo.Unknown,
    isBillableLiver: YesNo.Unknown,
    isSuspended: YesNo.Unknown,
    isRdnParticipant: YesNo.Unknown,
    isMedicalBoard: YesNo.Unknown,
    reduceEmails: YesNo.Unknown,
    isUtilizing3gKidneyForLife: YesNo.Unknown,
    doesAntibodyScreening: YesNo.No,
    getsFreeCheekSwabs: YesNo.No,
    hasAgreedToFees: YesNo.Unknown,
    isAllIn: YesNo.Unknown,
    isAdpPartner: YesNo.Unknown,
    isDcnParticipant: YesNo.Unknown,
    isFamilyVoucherParticipant: YesNo.No,
    isMicrositeParticipant: YesNo.Unknown,
    isMicrositeReferralCenter: YesNo.Unknown,
    isAccParticipant: null,
    hasCenterBilling: YesNo.Unknown,
    ccbReviewDays: 7,
    useMicrositeResponsibilityConfirmation: YesNo.Unknown,
    isDppParticipant: YesNo.Unknown,
    hasRecipientShield: YesNo.No,
    isStreamlinedBilling: YesNo.Unknown,
    isFollowUpParticipant: YesNo.Unknown,
    dashType: null,
    isInDonorShield: DonorShieldStatus.Off,
    isGoldStar: YesNo.Unknown,
    isDonorShieldDirectLiverCenter: YesNo.No,
    isInListingService: YesNo.Unknown,
    isPrivate: YesNo.Unknown,
    paysUsViaAch: YesNo.No,
    isExpertSystemParticipant: YesNo.No,
    doesGraftFailureQuestions: YesNo.No,
    nkrBillingComments: '',
    files: [],
    isPatientReferralNetwork: YesNo.No,
    isMicrositeCenterOfExcellence: YesNo.No,
    isNutcrackerCenterOfExcellence: YesNo.No,
    isStrongBoxCenter: YesNo.No,
    latitude: null,
    longitude: null,

}

export const initialAdminValidationData: IAdminDataValidation = {
    alias: true,
    invoicePoStartDate: true,
    invoicePoExpirationDate: true,
    latitude: true,
    longitude: true,
    routingNumber: true,
    packagingRoutingNumber: true
}

export const initialSrtrData: ISrtrData = {
    centerId: -1,
    hasGraftSurvivalFile: false,
    dcAdultGraftSurvival1: 0,
    dcAdultGraftSurvival3: 0,
    dcPediatricGraftSurvival1: 0,
    dcPediatricGraftSurvival3: 0,
    adultGraftSurvival1: 0,
    adultGraftSurvival3: 0,
    pediatricGraftSurvival1: 0,
    pediatricGraftSurvival3: 0,
    dcAdultPatientSurvival1: 0,
    dcAdultPatientSurvival3: 0,
    dcPediatricPatientSurvival1: 0,
    dcPediatricPatientSurvival3: 0,
    adultPatientSurvival1: 0,
    adultPatientSurvival3: 0,
    pediatricPatientSurvival1: 0,
    pediatricPatientSurvival3: 0,
    graftSurvivalNewFile: null,
    graftSurvivalDocumentsVersions: [],
    graftSurvivalVersionedFiles: [],
    patientSurvivalNewFile: null,
    patientSurvivalDocumentsVersions: [],
    patientSurvivalVersionedFiles: [],
    srtrSourceDate: '',
    unosId: ''
};

export const initialSrtrValidationData: ISrtrDataValidation = {
    dcAdultGraftSurvival1: true,
    dcAdultGraftSurvival3: true,
    dcPediatricGraftSurvival1: true,
    dcPediatricGraftSurvival3: true,
    adultGraftSurvival1: true,
    adultGraftSurvival3: true,
    pediatricGraftSurvival1: true,
    pediatricGraftSurvival3: true,
    dcAdultPatientSurvival1: true,
    dcAdultPatientSurvival3: true,
    dcPediatricPatientSurvival1: true,
    dcPediatricPatientSurvival3: true,
    adultPatientSurvival1: true,
    adultPatientSurvival3: true,
    pediatricPatientSurvival1: true,
    pediatricPatientSurvival3: true,
    srtrSourceDate: true,
    centerUnosId: true
};

export const initialProfileData: IProfileData = {
    centerId: -1,
    name: '',
    webUrl: '',
    earliestOrganPickupTime: '',
    latestOrganPickupTime: '',
    timezone: '',
    avgCostLDEvalWorkup: '',
    achRoutingNumber: '',
    achAccountNumber: '',
    newAchAccountNumber: '',
    invoiceDaysToRemit: '',
    streamlinedHospitalBilling: false,
    physicianDonorNephrectomyCharges: '',
    provideSwapChecklists: false,
    canUtilizeA2toBPatients: false,
    w9FormPath: '',
    newW9File: null,
    cmsFormPath: '',
    newCmsFile: null,
    salesTaxFile: null,
    isTaxExempt: null,
    taxExemptExpirationDate: null,
    leadCoordinatorId: 0
};

export const initialProfileValidationData: IProfileDataValidation = {
    name: true,
    webUrl: true,
    earliestPickupTime: 1,
    latestOrganPickupTime: true,
    timezone: true,
    taxExemptExpirationDate: true,
    newTaxFile: true,
    leadCoordinator: true
}

export const initialServicesData: IServicesData = {
    isFamilyVoucherParticipant: false,
    hasVoucherRestrictions: -1,
    performsIncompatibleTransplants: -1,
    performsDesensitization: -1,
    performsNonSteroidProtocol: -1,
    maxPairWorkups: '',
    minimumNddAge: '',
    providesDonorInsurance: -1,
    donorWorkupWait: '',
    recipientWorkupWait: '',
    maximumNddAge: '',
    chainEndTarget: 0,
    hasAbPatients: -1,
    maxBulkCheekSwabsWithin24Hours: '',
    // doesA2ChainEndOptimization: 0,
    canUtilizeA2toBPatients: -1,
    livingDonorFullfillJobAsDonorNav: null
};

export const initialServicesValidationData: IServicesDataValidation = {
    maximumNddAge: true,
    minimumNddAge: true
};

export const initialAnatomyPrefsData: IAnatomyPrefsData = {
    anatomyPrefArteriesLeft: null,
    anatomyPrefArteriesRight: null,
    anatomyPrefVeinsLeft: null,
    anatomyPrefVeinsRight: null,
    complianceWaitListAnatomy: null
};

export const initialLabData: ILabData = {
    centerId: 0,
    hasFrozenExploratory: false,
    hasFrozenScreening: false,
    xmVirtualOption: 0,
    labLavender85: 0,
    labLavender40: 0,
    labLavender70: 0,
    labLavender100: 0,
    labPink60: 0,
    labPink100: 0,
    labRed70: 0,
    labRed100: 0,
    labGreen100: 0,
    labYellow85: 0,
    transLavender85: 0,
    transLavender40: 0,
    transLavender70: 0,
    transLavender100: 0,
    transPink60: 0,
    transPink100: 0,
    transRed70: 0,
    transRed100: 0,
    transGreen100: 0,
    transYellow85: 0
};

// export const initialLegalDocumentsData: ILegalDocumentsData = {
//     centerContract: null,
//     centerAllInAgreemnet: null,
//     donorProtectionProgramAddendum: null,
//     recipientCenterAgreement: null,
//     donorCenterAgreement: null,
//     baa: null,
//     partnerAgreement: null,
//     dcnAgreement: null,
//     donorShieldAgreement: null
// };

export const initialSerologyData: ISerologyData = {
    serologyMaxDaysBeforeSurgery: 10,
    requiresQfg: -1,
    serologyShipToId: -1,
    serologyTests: []
};

export const initialSerologyValidationData: ISerologyDataValidation = {
    serologyMaxDaysBeforeSurgery: true,
    serologyShipToId: true
};

// export const timeZoneList: IListItem[] = [
//     { id: 0, description: 'PST' },
//     { id: 1, description: 'MST' },
//     { id: 2, description: 'Phoenix - No DST' },
//     { id: 3, description: 'CST' },
//     { id: 4, description: 'EST' },
//     { id: 5, description: 'HST' },
// ];

export const daysBeforeSurgeryList = _.range(10, 22).map(day => {
    return { id: day, description: day.toString() };
});

